import { createContext } from 'react';
export var phantomContextDefaultValue = {
    walletAddress: null,
    connectWallet: function () { return Promise.resolve(null); },
    signMessage: function () { return Promise.resolve(null); },
    error: null,
    signIn: function () { return Promise.resolve(null); },
    handleSignIn: function () { return Promise.resolve(); },
    provider: null,
    useLedgerSwitch: {
        checked: false,
        toggle: function () { },
    },
    publicKey: null,
    setRedirectUri: function () { },
    redirectUri: null,
};
export var PhantomContext = createContext(phantomContextDefaultValue);
